module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    staticClass: "brand-fact-sheet-page",
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "transition": "fade-transition"
    }
  }, [(_vm.type) ? _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "feedbackform",
    staticClass: "brand-fact-sheet-form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(_vm.type === _vm.campaignTypes.STORY_TELL) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandSheetLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v("STORYTELL - BRAND FACT SHEET")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/brand_sheet/storytell_bg.jpg"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetFormSections.sectionOne.title))])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetFormSections.sectionOne.subtitle))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetFormSections.sectionOne.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.hint && field.hint !== '') ? _c('p', {
      staticClass: "caption caption-text ma-0 pb-2",
      domProps: {
        "innerHTML": _vm._s(field.hint)
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textbox') ? _c('v-text-field', {
      class: field.class ? field.class + ' mt-0' : 'mt-0',
      attrs: {
        "outlined": "",
        "dense": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
      attrs: {
        "outlined": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'select') ? _c('v-select', {
      attrs: {
        "items": field.defaultOptions,
        "outlined": "",
        "dense": ""
      },
      on: {
        "change": function($event) {
          return _vm.changeSelect(field.name, _vm.brandSheet[field.name])
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e()], 1)])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetFormSections.sectionTwo.title))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetFormSections.sectionTwo.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.hint && field.hint !== '') ? _c('p', {
      staticClass: "caption caption-text ma-0 pb-2",
      domProps: {
        "innerHTML": _vm._s(field.hint)
      }
    }) : _vm._e(), _vm._v(" "), (field.name === 'campaignBudget') ? _c('div', {
      staticClass: "d-flex flex-row"
    }, [_c('v-select', {
      staticClass: "currency-select",
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "items": _vm.currenyOptions,
        "hide-details": "",
        "dense": "",
        "outlined": ""
      },
      model: {
        value: (_vm.brandSheet.budgetCurrency),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, "budgetCurrency", _vm._n($$v))
        },
        expression: "brandSheet.budgetCurrency"
      }
    }), _vm._v(" "), (field.type === 'textbox') ? _c('v-text-field', {
      class: field.class ? field.class + ' mt-0' : 'mt-0',
      attrs: {
        "outlined": "",
        "dense": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": "",
        "type": field.numberText ? 'number' : ''
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (field.type === 'textbox' && field.name !== 'campaignBudget') ? _c('v-text-field', {
      class: field.class ? field.class + ' mt-0' : 'mt-0',
      attrs: {
        "outlined": "",
        "dense": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": "",
        "type": field.numberText ? 'number' : ''
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
      attrs: {
        "outlined": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e()], 1)])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetFormSections.sectionThree.title))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetFormSections.sectionThree.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.hint && field.hint !== '') ? _c('p', {
      staticClass: "caption caption-text ma-0 pb-2",
      domProps: {
        "innerHTML": _vm._s(field.hint)
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textbox') ? _c('v-text-field', {
      class: field.class ? field.class + ' mt-0' : 'mt-0',
      attrs: {
        "outlined": "",
        "dense": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
      attrs: {
        "outlined": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'select') ? _c('v-select', {
      attrs: {
        "items": field.defaultOptions,
        "item-text": "text",
        "item-value": "value",
        "outlined": "",
        "dense": ""
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'checkbox') ? _c('v-layout', {
      attrs: {
        "wrap": "",
        "justify-center": "",
        "mb-2": ""
      }
    }, _vm._l((field.detailFields), function(df) {
      return _c('v-flex', {
        key: df.key,
        attrs: {
          "xs12": "",
          "md12": ""
        }
      }, [_c('v-checkbox', {
        staticClass: "mt-0",
        attrs: {
          "label": df.label,
          "value": df.value
        },
        model: {
          value: (_vm.brandSheet[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.brandSheet, field.name, $$v)
          },
          expression: "brandSheet[field.name]"
        }
      })], 1)
    }), 1) : _vm._e(), _vm._v(" "), (field.type === 'file') ? _c('div', {
      staticClass: "mb-3"
    }, [_c('v-btn', {
      staticClass: "white--text",
      attrs: {
        "color": "blue-grey"
      },
      on: {
        "click": function($event) {
          return _vm.$refs.mediaUpload.click()
        }
      }
    }, [_vm._v("\n                          Upload\n                          "), _c('v-icon', {
      attrs: {
        "right": "",
        "dark": ""
      }
    }, [_vm._v("\n                            mdi-cloud-upload\n                          ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [(_vm.images.length > 0) ? _c('v-row', _vm._l((_vm.images), function(img, index) {
      return _c('v-col', {
        key: index,
        staticClass: "d-flex child-flex",
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1"
        }
      }, [_c('v-hover', {
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var hover = ref.hover;

            return [_c('v-card', {
              staticClass: "d-flex",
              attrs: {
                "flat": "",
                "tile": "",
                "elevation": hover ? 16 : 2
              }
            }, [_c('v-img', {
              staticClass: "grey lighten-2",
              attrs: {
                "src": img.url,
                "lazy-src": img.url,
                "aspect-ratio": "1"
              }
            }), _vm._v(" "), _c('v-overlay', {
              attrs: {
                "absolute": ""
              }
            }, [_c('v-btn', {
              attrs: {
                "dark": "",
                "icon": ""
              },
              on: {
                "click": function($event) {
                  return _vm.deleteImage(index)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "dark": "",
                "color": "red"
              }
            }, [_vm._v("cancel")])], 1)], 1)], 1)]
          }
        }], null, true)
      })], 1)
    }), 1) : _vm._e(), _vm._v(" "), (_vm.decksFiles.length > 0) ? _c('v-row', _vm._l((_vm.decksFiles), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/pdf.png",
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/ppt.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/doc.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
        attrs: {
          "dark": "",
          "icon": ""
        },
        on: {
          "click": function($event) {
            return _vm.deleteFile(index)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "dark": "",
          "color": "red"
        }
      }, [_vm._v("cancel")])], 1)], 1)
    }), 1) : _vm._e()], 1)], 1) : _vm._e()], 1)])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.$v.brandSheet.$error) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v("Please complete all required fields. *")])])], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitBrandSheet.apply(null, arguments)
      }
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v("\n                  Submit\n                ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type === _vm.bfsTypes.AOK || _vm.type === _vm.bfsTypes.Uncut) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandSheetLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v("KOBE Uncut - BRAND FACT SHEET")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetAOKFormSections.sectionOne.title))])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetAOKFormSections.sectionOne.subtitle))])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/brand_sheet/aok_bg.png"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("LEAD TIME")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("14 days upon receiving this brand fact sheet and logistics from the client.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("TIME/DATE OF PUBLISH")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Creators are free to post at any preferred time and day during the campaign period.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("SELECTION CRITERIA")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("Profiles proposed will be screened for audience credibility on KOBE Patented Influencer Management System (IMS)")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("For niche requirements (for example, ethnicity, professions) , please opt for storytell packages instead.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CREATORS CONTENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CAMPAIGN INFORMATION SHARING")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("KOBE will manage the campaign as per information shared by clients in this brand fact sheet. By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("LOGISTICS ARRANGEMENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("It is recommended for our clients to make your own logistics arrangements.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("For clients that are unable to handle logistics, KOBE will offer complimentary logistics service for our clients with products (not including perishable goods or items that require special handling or storage) that are below 2kg and parcel size (length + width + height) does not exceed 120cm.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("Product has to be sent over to KOBE in 1 shipment before it is disseminated to the creators on your behalf.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("There will be a 5 working day turnaround for all logistics arrangements.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("KOBE will not be responsible for any damaged or lost parcels.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("ADDITIONAL ENGAGEMENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("Kindly note that any additional engagements listed here are not applicable for KOBE Uncut campaigns and you could opt for Storytell campaign and are chargeable, kindly ensure that requirements are stated clearly with your Client Engagement Representative before launching of the campaign:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("● Contest giveaway on social media ● Photoshoot for client ● Video appearance in client’s own production ● Usage of photos/videos from creators as Ads online or offline ● Promo Code Shoutout ● Link in Bio/Swipe Up")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetAOKFormSections.sectionOne.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.hint && field.hint !== '') ? _c('p', {
      staticClass: "caption caption-text ma-0 pb-2",
      domProps: {
        "innerHTML": _vm._s(field.hint)
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textbox') ? _c('v-text-field', {
      class: field.class ? field.class + ' mt-0' : 'mt-0',
      attrs: {
        "outlined": "",
        "dense": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
      attrs: {
        "outlined": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'file') ? _c('div', {
      staticClass: "mb-3"
    }, [_c('v-btn', {
      staticClass: "white--text",
      attrs: {
        "color": "blue-grey"
      },
      on: {
        "click": function($event) {
          return _vm.$refs.mediaUpload.click()
        }
      }
    }, [_vm._v("\n                          Upload\n                          "), _c('v-icon', {
      attrs: {
        "right": "",
        "dark": ""
      }
    }, [_vm._v("\n                            mdi-cloud-upload\n                          ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [(_vm.images.length > 0) ? _c('v-row', _vm._l((_vm.images), function(img, index) {
      return _c('v-col', {
        key: index,
        staticClass: "d-flex child-flex",
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1"
        }
      }, [_c('v-hover', {
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var hover = ref.hover;

            return [_c('v-card', {
              staticClass: "d-flex",
              attrs: {
                "flat": "",
                "tile": "",
                "elevation": hover ? 16 : 2
              }
            }, [_c('v-img', {
              staticClass: "grey lighten-2",
              attrs: {
                "src": img.url,
                "lazy-src": img.url,
                "aspect-ratio": "1"
              }
            }), _vm._v(" "), _c('v-overlay', {
              attrs: {
                "absolute": ""
              }
            }, [_c('v-btn', {
              attrs: {
                "dark": "",
                "icon": ""
              },
              on: {
                "click": function($event) {
                  return _vm.deleteImage(index)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "dark": "",
                "color": "red"
              }
            }, [_vm._v("cancel")])], 1)], 1)], 1)]
          }
        }], null, true)
      })], 1)
    }), 1) : _vm._e(), _vm._v(" "), (_vm.decksFiles.length > 0) ? _c('v-row', _vm._l((_vm.decksFiles), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/pdf.png",
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/ppt.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/doc.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
        attrs: {
          "dark": "",
          "icon": ""
        },
        on: {
          "click": function($event) {
            return _vm.deleteFile(index)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "dark": "",
          "color": "red"
        }
      }, [_vm._v("cancel")])], 1)], 1)
    }), 1) : _vm._e()], 1)], 1) : _vm._e()], 1)])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.$v.brandSheet.$error) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v("Please complete all required fields. *")])])], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitBrandSheet.apply(null, arguments)
      }
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v(" Submit\n                ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type === _vm.bfsTypes.KOBE_LITE) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandSheetLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v("KOBE Lite - BRAND FACT SHEET")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetKobeLiteFormSections.sectionOne.title))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("LEAD TIME")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("14 days upon receiving this brand fact sheet and logistics from the client.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("TIME/DATE OF PUBLISH")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Creators are free to post at any preferred time and day during the campaign period.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CREATORS CONTENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CAMPAIGN INFORMATION SHARING")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetKobeLiteFormSections.sectionOne.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.hint && field.hint !== '') ? _c('p', {
      staticClass: "caption caption-text ma-0 pb-2",
      domProps: {
        "innerHTML": _vm._s(field.hint)
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textbox') ? _c('v-text-field', {
      class: field.class ? field.class + ' mt-0' : 'mt-0',
      attrs: {
        "outlined": "",
        "dense": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
      attrs: {
        "outlined": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'file') ? _c('div', {
      staticClass: "mb-3"
    }, [_c('v-btn', {
      staticClass: "white--text",
      attrs: {
        "color": "blue-grey"
      },
      on: {
        "click": function($event) {
          return _vm.$refs.mediaUpload.click()
        }
      }
    }, [_vm._v("\n                          Upload\n                          "), _c('v-icon', {
      attrs: {
        "right": "",
        "dark": ""
      }
    }, [_vm._v("\n                            mdi-cloud-upload\n                          ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [(_vm.images.length > 0) ? _c('v-row', _vm._l((_vm.images), function(img, index) {
      return _c('v-col', {
        key: index,
        staticClass: "d-flex child-flex",
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1"
        }
      }, [_c('v-hover', {
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var hover = ref.hover;

            return [_c('v-card', {
              staticClass: "d-flex",
              attrs: {
                "flat": "",
                "tile": "",
                "elevation": hover ? 16 : 2
              }
            }, [_c('v-img', {
              staticClass: "grey lighten-2",
              attrs: {
                "src": img.url,
                "lazy-src": img.url,
                "aspect-ratio": "1"
              }
            }), _vm._v(" "), _c('v-overlay', {
              attrs: {
                "absolute": ""
              }
            }, [_c('v-btn', {
              attrs: {
                "dark": "",
                "icon": ""
              },
              on: {
                "click": function($event) {
                  return _vm.deleteImage(index)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "dark": "",
                "color": "red"
              }
            }, [_vm._v("cancel")])], 1)], 1)], 1)]
          }
        }], null, true)
      })], 1)
    }), 1) : _vm._e(), _vm._v(" "), (_vm.decksFiles.length > 0) ? _c('v-row', _vm._l((_vm.decksFiles), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/pdf.png",
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/ppt.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/doc.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
        attrs: {
          "dark": "",
          "icon": ""
        },
        on: {
          "click": function($event) {
            return _vm.deleteFile(index)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "dark": "",
          "color": "red"
        }
      }, [_vm._v("cancel")])], 1)], 1)
    }), 1) : _vm._e()], 1)], 1) : _vm._e()], 1)])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.$v.brandSheet.$error) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v("Please complete all required fields. *")])])], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitBrandSheet.apply(null, arguments)
      }
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v(" Submit\n                ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type === _vm.bfsTypes.UGC || _vm.type === _vm.bfsTypes.UGC) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandSheetLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v("UGC (User-Generated-Content) Videos Application Form")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "I am aware that kobe’s full service of S$15k and up, includes: ",
      "value": "aggreedKobeServiceInclude"
    },
    model: {
      value: (_vm.brandSheet['aggreedKobeServiceInclude']),
      callback: function($$v) {
        _vm.$set(_vm.brandSheet, 'aggreedKobeServiceInclude', $$v)
      },
      expression: "brandSheet['aggreedKobeServiceInclude']"
    }
  }), _vm._v(" "), (_vm.$v.brandSheet['aggreedKobeServiceInclude'].$error) ? _c('p', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v("This field is required!")]) : _vm._e(), _vm._v(" "), _c('p', [_c('ul', [_c('li', [_vm._v("Marketing goal, objective, and influence strategy consultation, incorporating the availability heuristic, bandwagon effect, and clustering effect for cognitive and emotive influence.")]), _vm._v(" "), _c('li', [_vm._v("Development of social media content concepts and strategies using 7X award-winning A.U.D.I framework.")]), _vm._v(" "), _c('li', [_vm._v("Curated creator identification through patented proprietary software, unveiling deep insights into social performance, audience demographics, and creator interest and personality profiling.")]), _vm._v(" "), _c('li', [_vm._v("Comprehensive creator relationship management services, including content curation, quality assurance, vetting and scheduling.")]), _vm._v(" "), _c('li', [_vm._v("Tailored content direction and brief design aligned with marketing objectives, encompassing recommendations for hashtags, captions, content direction, platform selection, optimal timing, and social SEO optimization.")]), _vm._v(" "), _c('li', [_vm._v("Up to 3 accesses to our Influencer Management System® to streamline influencer campaign management.")]), _vm._v(" "), _c('li', [_vm._v("Access to dedicated account managers, strategy planners, and community curators, providing expert recommendations and support.")])])]), _vm._v(" "), _c('p', [_vm._v("Lead time: 4 weeks")])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', [_vm._v("Process:")]), _vm._v(" "), _c('v-img', {
    staticStyle: {
      "max-width": "800px"
    },
    attrs: {
      "src": "/static/img/brand_sheet/ugc_process.png"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("TIME/DATE OF PUBLISH")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Creators are free to post at any preferred time and day during the campaign period.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("INFLUENCER SELECTION")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Influencer selection is interest and response based. Based on what you complete within this form, the information will be distributed to 10,000 individuals with follower counts up to 3,000. The interested recipients will respond accordingly.You are not allowed to modify the requirements of creator quality, quantity, specification.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CREATORS CONTENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference. You are not allowed to request for reshoot, edits or amendments.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("INFORMATION SHARING")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("KOBE will manage the campaign as per information shared by clients in this brand fact sheet. By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("LOGISTICS ARRANGEMENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', [_vm._v("For products")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Client to send products to creators directly for free")]), _vm._v(" "), _c('li', [_vm._v("Client to arrange a pick-up point for creators to collect the products directly")]), _vm._v(" "), _c('li', [_vm._v("Creator can make the purchase of product with attached receipt for 100% reimbursement from client")])])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', [_vm._v("For experience")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Creator attend the experience directly and client to verify")]), _vm._v(" "), _c('li', [_vm._v("Creator can make the purchase of experience with attached receipt for 100% reimbursement from client")])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("UGC VIDEOS TRACKING")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("You will receive email notification via your email address provided below each time a creator submits their content. The campaign concludes once the number of UGC videos achieves the number agreed.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("POST CAMPAIGN")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("You will have direct access to creator contact information for the purpose of relationship building, additional collaborations. Kobe will assume a non-interventionist role and will not levy any charges or engage in mediation with respect to the relationship. You are granted unrestricted discretion to communicate and negotiate according to your preferences.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetAOKFormSections.sectionOne.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.hint && field.hint !== '') ? _c('p', {
      staticClass: "caption caption-text ma-0 pb-2",
      domProps: {
        "innerHTML": _vm._s(field.hint)
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textbox') ? _c('v-text-field', {
      class: field.class ? field.class + ' mt-0' : 'mt-0',
      attrs: {
        "outlined": "",
        "dense": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
      attrs: {
        "outlined": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.name === 'productExperienceType') ? _c('div', [_c('v-radio-group', {
      attrs: {
        "row": ""
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }, [_c('v-radio', {
      attrs: {
        "label": "Deliver directly",
        "value": "Deliver directly"
      }
    }), _vm._v(" "), _c('v-radio', {
      attrs: {
        "label": "Pick Up Point",
        "value": "Pick Up Point"
      }
    }), _vm._v(" "), _c('v-radio', {
      attrs: {
        "label": "Reimbursement Basis",
        "value": "Reimbursement Basis"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (field.name === 'sampleVideoContent') ? _c('div', {
      staticClass: "mb-3"
    }, [_vm._l((_vm.brandSheet.sampleVideoContent), function(vt, index) {
      return _c('div', {
        key: index,
        staticClass: "d-flex flex-row"
      }, [_c('v-text-field', {
        staticClass: "mt-0",
        attrs: {
          "outlined": "",
          "dense": "",
          "placeholder": ""
        },
        model: {
          value: (vt.link),
          callback: function($$v) {
            _vm.$set(vt, "link", $$v)
          },
          expression: "vt.link"
        }
      }), _vm._v(" "), (_vm.brandSheet.sampleVideoContent.length > 1) ? _c('v-btn', {
        attrs: {
          "color": "danger",
          "text": "",
          "x-small": ""
        },
        on: {
          "click": function($event) {
            return _vm.brandSheet.sampleVideoContent.splice(index, 1)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "red"
        }
      }, [_vm._v("mdi-delete-forever")])], 1) : _vm._e()], 1)
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.addVideoURL()
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-plus")]), _vm._v(" Add\n                          ")], 1)], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "white--text",
      attrs: {
        "color": "blue-grey"
      },
      on: {
        "click": function($event) {
          return _vm.$refs.videoUpload.click()
        }
      }
    }, [_vm._v("\n                          Upload\n                          "), _c('v-icon', {
      attrs: {
        "right": "",
        "dark": ""
      }
    }, [_vm._v("\n                            mdi-cloud-upload\n                          ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [(_vm.videos.length > 0) ? _c('v-row', _vm._l((_vm.videos), function(vdo, index) {
      return _c('v-col', {
        key: index,
        staticClass: "d-flex child-flex",
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1"
        }
      }, [_c('v-hover', {
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var hover = ref.hover;

            return [_c('v-card', {
              staticClass: "d-flex",
              attrs: {
                "flat": "",
                "tile": "",
                "elevation": hover ? 16 : 2
              }
            }, [_c('v-img', {
              staticClass: "grey lighten-2",
              attrs: {
                "src": vdo.url,
                "lazy-src": vdo.url,
                "aspect-ratio": "1"
              }
            }), _vm._v(" "), _c('v-overlay', {
              attrs: {
                "absolute": ""
              }
            }, [_c('v-btn', {
              attrs: {
                "dark": "",
                "icon": ""
              },
              on: {
                "click": function($event) {
                  return _vm.deleteVideo(index)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "dark": "",
                "color": "red"
              }
            }, [_vm._v("cancel")])], 1)], 1)], 1)]
          }
        }], null, true)
      })], 1)
    }), 1) : _vm._e(), _vm._v(" "), (_vm.videoFiles.length > 0) ? _c('v-row', _vm._l((_vm.videoFiles), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [_c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png",
          "aspect-ratio": "1"
        }
      })], 1), _vm._v(" "), _c('v-btn', {
        attrs: {
          "dark": "",
          "icon": ""
        },
        on: {
          "click": function($event) {
            return _vm.deleteVideoFile(index)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "dark": "",
          "color": "red"
        }
      }, [_vm._v("cancel")])], 1)], 1)
    }), 1) : _vm._e()], 1)], 2) : _vm._e(), _vm._v(" "), (field.name === 'marketingCollaterals') ? _c('div', {
      staticClass: "mb-3"
    }, [_vm._l((_vm.brandSheet.marketingURL), function(mct, index) {
      return _c('div', {
        key: index,
        staticClass: "d-flex flex-row"
      }, [_c('v-text-field', {
        staticClass: "mt-0",
        attrs: {
          "outlined": "",
          "dense": "",
          "placeholder": ""
        },
        model: {
          value: (mct.link),
          callback: function($$v) {
            _vm.$set(mct, "link", $$v)
          },
          expression: "mct.link"
        }
      }), _vm._v(" "), (_vm.brandSheet.marketingURL.length > 1) ? _c('v-btn', {
        attrs: {
          "color": "danger",
          "text": "",
          "x-small": ""
        },
        on: {
          "click": function($event) {
            return _vm.brandSheet.marketingURL.splice(index, 1)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "red"
        }
      }, [_vm._v("mdi-delete-forever")])], 1) : _vm._e()], 1)
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.addMarketingURL()
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-plus")]), _vm._v(" Add\n                          ")], 1)], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "white--text",
      attrs: {
        "color": "blue-grey"
      },
      on: {
        "click": function($event) {
          return _vm.$refs.mediaUpload.click()
        }
      }
    }, [_vm._v("\n                          Upload\n                          "), _c('v-icon', {
      attrs: {
        "right": "",
        "dark": ""
      }
    }, [_vm._v("\n                            mdi-cloud-upload\n                          ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [(_vm.images.length > 0) ? _c('v-row', _vm._l((_vm.images), function(img, index) {
      return _c('v-col', {
        key: index,
        staticClass: "d-flex child-flex",
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1"
        }
      }, [_c('v-hover', {
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var hover = ref.hover;

            return [_c('v-card', {
              staticClass: "d-flex",
              attrs: {
                "flat": "",
                "tile": "",
                "elevation": hover ? 16 : 2
              }
            }, [_c('v-img', {
              staticClass: "grey lighten-2",
              attrs: {
                "src": img.url,
                "lazy-src": img.url,
                "aspect-ratio": "1"
              }
            }), _vm._v(" "), _c('v-overlay', {
              attrs: {
                "absolute": ""
              }
            }, [_c('v-btn', {
              attrs: {
                "dark": "",
                "icon": ""
              },
              on: {
                "click": function($event) {
                  return _vm.deleteImage(index)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "dark": "",
                "color": "red"
              }
            }, [_vm._v("cancel")])], 1)], 1)], 1)]
          }
        }], null, true)
      })], 1)
    }), 1) : _vm._e(), _vm._v(" "), (_vm.decksFiles.length > 0) ? _c('v-row', _vm._l((_vm.decksFiles), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/pdf.png",
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/ppt.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/doc.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
        attrs: {
          "dark": "",
          "icon": ""
        },
        on: {
          "click": function($event) {
            return _vm.deleteFile(index)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "dark": "",
          "color": "red"
        }
      }, [_vm._v("cancel")])], 1)], 1)
    }), 1) : _vm._e()], 1)], 2) : _vm._e()], 1)])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.$v.brandSheet.$error) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v("Please complete all required fields. *")])])], 1) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    staticClass: "h4 font-weight-bold mb-2 prefer-video-chk",
    attrs: {
      "label": "I prefer to receive the videos without the creators posting it on their social media platform.",
      "value": "preferVideosWithoutCreatorsPosting"
    },
    model: {
      value: (_vm.brandSheet['preferVideosWithoutCreatorsPosting']),
      callback: function($$v) {
        _vm.$set(_vm.brandSheet, 'preferVideosWithoutCreatorsPosting', $$v)
      },
      expression: "brandSheet['preferVideosWithoutCreatorsPosting']"
    }
  }), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitBrandSheet.apply(null, arguments)
      }
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v(" Submit\n                ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "mediaUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "media",
      "id": "fileToUpload",
      "accept": "image/*, .pdf, .ppt, .txt, .doc, .docx"
    },
    on: {
      "change": _vm.prepareUpload
    }
  }), _vm._v(" "), _c('input', {
    ref: "videoUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "video",
      "id": "videoToUpload",
      "accept": "video/*"
    },
    on: {
      "change": _vm.prepareVideoUpload
    }
  })], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46aa5388"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/BrandSheetForm.vue
// module id = 2104
// module chunks = 0